export const settingDict = {
    en: {
      "Account": "Account",
      "Change Password": "Change Password",
      "Edit Account": "Edit Account",
      "Subscribe Indiapolls": "Subscribe DataXing",
      "Request Deletion of Account": "Request Deletion of Account",
      "Gender": "Gender",
      "Mobile": "Mobile",
      "DOB": "DOB",
      "Address": "Address",
      "Pin Code": "Pin Code",
      "Country": "Country",
      "State": "State",
      "City": "City",
      "Profile names to be same as profile": "Profile names to be same as profile",
      "Unsubscribe Confirmation": "Are you sure want to unsubscribe from DataXing?",
      "Subscribe Confirmation": "Are you sure want to Subscribe DataXing?",
      "Deletion Confirmation" : "Are you sure want to create delete request?",
      "Verified" : "Verified",
      "Not-Verified" : "Not-Verified", 
      "Unsubscribe From Indiapolls" : "Unsubscribe From DataXing",
      "Verify" : "Verify"
    },
    hi: {
      "Account": "खाता",
      "Change Password": "पासवर्ड बदलें",
      "Edit Account": "खाता संपादित करें",
      "Subscribe Indiapolls": "DataXing की सदस्यता लें",
      "Request Deletion of Account": "खाता हटाने का अनुरोध",
      "Gender": "लिंग",
      "Mobile": "मोबाइल",
      "DOB": "जन्म तिथि",
      "Address": "पता",
      "Pin Code": "पिन कोड",
      "Country": "देश",
      "State": "राज्य",
      "City": "शहर",
      "Profile names to be same as profile": "प्रोफ़ाइल नाम प्रोफ़ाइल के समान होने के लिए",
      "Unsubscribe Confirmation": "क्या आप वाकई DataXing से अनसब्सक्राइब करना चाहते हैं?",
      "Subscribe Confirmation": "क्या आप वाकई DataXing को सब्सक्राइब करना चाहते हैं?",
      "Deletion Confirmation" : "क्या आप वाकई में हटाने का अनुरोध बनाना चाहते हैं?", 
      "Verified" : "सत्यापित",
      "Not-Verified" : "सत्यापित नहीं है",
      "Unsubscribe From Indiapolls" : "DataXing से सदस्यता हटाए ",
      "Verify" : "सत्यापित करें"
    }
};

export const mobileVerificationDict = {
  en: {
    "Mobile Verification": "Mobile Verification",
    "Enter OTP": "Enter OTP",
    "Verify Mobile": "Verify",
    "Resend OTP": "Resend",
  },
  hi: {
    "Mobile Verification": "मोबाइल सत्यापन",
    "Enter OTP": "ओटीपी दर्ज करें",
    "Verify Mobile": "सत्यापित करें",
    "Resend OTP" : "पुनः भेजे"
  }
};

export const formFieldDict = {
  en: {
    "First name": "First name",
    "Last Name": "Last Name",
    "Email": "Email",
    "Mobile Number": "Mobile Number",
    "Gender": "Gender",
    "Date Of Birth": "Date Of Birth",
    "Pincode": "Pincode",
    "Address Line 1": "Address Line 1",
    "Address Line 2": "Address Line 2",
    "Country": "Country",
    "State": "State",
    "City": "City",
    "Referral Source": "Referral Source",
    "Submit": "Submit",
    "Reset": "Reset",
    "Enter here": "Enter here",
    "Enter here..": "Enter here..",
    "Choose": "--Choose--",
    "Male": "Male",
    "Female": "Female",
    "Select Referral": "Select Referral",
    "Ad flier with newspaper": "Ad flier with newspaper",
    "Ad flier at market/outdoors": "Ad flier at market/outdoors",
    "Saw an ad on a website": "Saw an ad on a website",
    "Read about it on a blog/forum": "Read about it on a blog/forum",
    "Ad at Café Coffee Day": "Ad at Café Coffee Day",
    "Got an email from a friend/colleague": "Got an email from a friend/colleague",
    "Email from a web portal/service/jobsite": "Email from a web portal/service/jobsite",
    "Searched on google.com": "Searched on google.com",
    "Other": "Other",
    "Searched on another search engine": "Searched on another search engine",
    "Ad at a shop/restaurant": "Ad at a shop/restaurant",
    "Word of mouth from friend/colleague": "Word of mouth from friend/colleague",
    "Update Profile" : "Update Profile"
  },
  hi: {
    "First name": "पहला नाम",
    "Last Name": "उपनाम",
    "Email": "ईमेल",
    "Mobile Number": "मोबाइल नंबर",
    "Gender": "लिंग",
    "Date Of Birth": "जन्म की तारीख",
    "Pincode": "पिन कोड",
    "Address Line 1": "पता पंक्ति 1",
    "Address Line 2": "पता पंक्ति 2",
    "Country": "देश",
    "State": "राज्य",
    "City": "शहर",
    "Referral Source": "रेफरल स्रोत",
    "Submit": "जमा करें",
    "Reset": "रीसेट करें",
    "Enter here": "यहाँ दर्ज करें",
    "Enter here..": "यहाँ लिखें..",
    "Choose": "--चुनें--",
    "Male": "पुरुष",
    "Female": "महिला",
    "Select Referral": "रेफरल का चयन करें",
    "Ad flier with newspaper": "अखबार के साथ विज्ञापन पत्रक",
    "Ad flier at market/outdoors": "बाजार/बाहर में विज्ञापन पत्रक",
    "Saw an ad on a website": "वेबसाइट पर विज्ञापन देखा",
    "Read about it on a blog/forum": "ब्लॉग/फोरम पर इसके बारे में पढ़ा",
    "Ad at Café Coffee Day": "कैफे कॉफी डे में विज्ञापन",
    "Got an email from a friend/colleague": "दोस्त/सहकर्मी से ईमेल प्राप्त हुआ",
    "Email from a web portal/service/jobsite": "वेब पोर्टल/सेवा/नौकरी साइट से ईमेल",
    "Searched on google.com": "google.com पर खोजा गया",
    "Other": "अन्य",
    "Searched on another search engine": "दूसरे खोज इंजन पर खोजा गया",
    "Ad at a shop/restaurant": "दुकान/रेस्तरां में विज्ञापन",
    "Word of mouth from friend/colleague": "दोस्त/सहकर्मी से मुख से जानकारी",
    "Update Profile" : "प्रोफ़ाइल संपादित करें"
  }
};

export const confirmationDict = {
  en: {
    "Confirmation": "Confirmation",
    "Are you sure?": "Are you sure?",
    "Changeable": "Changeable"
  },
  hi: {
    "Confirmation": "पुष्टिकरण",
    "Are you sure?": "क्या आपको यकीन है?",
    "Changeable": "परिवर्तनीय"
  }
};


